import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from "@nebular/auth";
import {
  NbComponentStatus,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import * as moment from "moment";
import { environment } from "../../../../environments/environment";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import Shop from "../../../models/shop.model";

import { ProfileService } from "../../../services/profile.service";

import { getDeepFromObject } from "../../helpers";
import { EMAIL_PATTERN } from "../constants";

@Component({
  selector: "ngx-register",
  styleUrls: ["./register.component.scss"],
  templateUrl: "./register.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRegisterComponent implements OnInit {
  minLoginLength: number = 1;
  maxLoginLength: number = 100;
  minLength: number = 6;
  maxLength: number = 50;
  isFullNameRequired: boolean = this.getConfigValue(
    "forms.validation.fullName.required"
  );
  isEmailRequired: boolean = this.getConfigValue(
    "forms.validation.email.required"
  );
  isPasswordRequired: boolean = this.getConfigValue(
    "forms.validation.password.required"
  );
  redirectDelay: number = this.getConfigValue("forms.register.redirectDelay");
  showMessages: any = this.getConfigValue("forms.register.showMessages");
  strategy: string = this.getConfigValue("forms.register.strategy");
  socialLinks: NbAuthSocialLink[] = this.getConfigValue(
    "forms.login.socialLinks"
  );

  loading = false;
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  // user: any = {};

  registerForm: FormGroup;
  shop: Shop = {
    code: "",
    title: "",
    description: "",
    email: "",
    mobile: "",
    product: false,
    customer: false,
    warehouse: false,
    finance: false,
    receipt: false,
    purchase: false,
    working: false,
    trade: false,
    isPremium: false,
    expDate: moment().add(1, "months").endOf("day").toDate(),
  };
  user: User = {
    displayName: "",
    email: "",
    password: "",
    admin: false,
    moderator: true,
    product: true,
    customer: true,
    warehouse: true,
    finance: true,
    receipt: true,
    purchase: true,
    working: true,
    salesman: false,
    printReceiptA4: true,
    printReceiptPos: true,
    role: "",
    language: "",
    shopId: "",
  };

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    private fb: FormBuilder,
    protected router: Router,
    public userService: UserService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private toastrService: NbToastrService
  ) {}

  get title() {
    return this.registerForm.get("title");
  }
  get address() {
    return this.registerForm.get("address");
  }
  get fullName() {
    return this.registerForm.get("fullName");
  }
  get mobile() {
    return this.registerForm.get("mobile");
  }
  get email() {
    return this.registerForm.get("email");
  }
  get password() {
    return this.registerForm.get("password");
  }
  get confirmPassword() {
    return this.registerForm.get("confirmPassword");
  }
  get terms() {
    return this.registerForm.get("terms");
  }

  ngOnInit(): void {
    if (!environment.allowRegister) {
      this.router.navigate(["home"]);
    }

    const isWorking =
      environment.firebase.projectId === "kasoft-store-working" ? true : false;
    if (isWorking) {
      this.shop.working = true;
      this.shop.finance = true;
      this.shop.customer = true;
    } else {
      this.shop.product = true;
      this.shop.customer = true;
      this.shop.warehouse = true;
      this.shop.finance = true;
      this.shop.receipt = true;
      this.shop.purchase = true;
      this.shop.trade = true;
    }

    this.route.queryParams.subscribe((params) => {
      this.shop.title = params["company"] ? params["company"] : "";
      this.shop.address = params["address"] ? params["address"] : "";
      this.shop.email = params["email"] ? params["email"] : "";
      this.shop.mobile = params["mobile"] ? params["mobile"] : "";

      this.user.email = params["email"] ? params["email"] : "";
      this.user.displayName = params["fullname"] ? params["fullname"] : "";
    });

    console.log("ngOnInit/user:", this.user);
    console.log("ngOnInit/shop:", this.shop);

    const loginValidators = [
      Validators.minLength(this.minLoginLength),
      Validators.maxLength(this.maxLoginLength),
    ];
    this.isFullNameRequired && loginValidators.push(Validators.required);

    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];
    this.isEmailRequired && emailValidators.push(Validators.required);

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    const stringValidators = [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(500),
    ];
    const mobileValidators = [
      Validators.required,
      Validators.minLength(9),
      Validators.maxLength(500),
    ];

    this.registerForm = this.fb.group({
      title: ["", stringValidators],
      address: ["", stringValidators],
      fullName: this.fb.control("", [...loginValidators]),
      mobile: this.fb.control("", [...mobileValidators]),
      email: this.fb.control("", [...emailValidators]),
      password: this.fb.control("", [...passwordValidators]),
      confirmPassword: this.fb.control("", [...passwordValidators]),
      terms: this.fb.control(""),
    });
  }

  register(): void {
    this.errors = this.messages = [];
    this.submitted = true;
    this.loading = true;

    //this.user = this.registerForm.value;
    // this.service
    //   .register(this.strategy, this.user)
    //   .subscribe((result: NbAuthResult) => {
    //     this.submitted = false;
    //     if (result.isSuccess()) {
    //       this.messages = result.getMessages();

    //       //save user profile to fireStore
    //       var response = result.getResponse();
    //       var userFb = response.user;

    //       this.userService.createUserData(
    //         userFb.uid,
    //         this.user.email,
    //         this.user.fullName
    //       );
    //       this.profileService.create(
    //         userFb.uid,
    //         this.user.email,
    //         this.user.fullName
    //       );
    //     } else {
    //       this.errors = result.getErrors();
    //     }

    //     const redirect = result.getRedirect();
    //     if (redirect) {
    //       setTimeout(() => {
    //         return this.router.navigateByUrl(redirect);
    //       }, this.redirectDelay);
    //     }
    //     this.cd.detectChanges();
    //   });

    this.shop.title = this.shop.title ? this.shop.title : "";
    this.shop.address = this.shop.address ? this.shop.address : "";
    this.shop.mobile = this.shop.mobile
      ? this.shop.mobile.replace(" ", "").trim()
      : "";
    this.shop.description = this.shop.description ? this.shop.description : "";

    this.user.displayName = this.user.displayName
      ? this.user.displayName
      : "User";
    this.user.email = this.user.email
      ? this.user.email.replace(" ", "").trim().toLowerCase()
      : "";
    this.user.password = this.user.password
      ? this.user.password.replace(" ", "").trim()
      : "";

    if (this.shop.trade) {
      this.shop.finance = true;
      this.shop.purchase = true;
    }

    if (!this.user.email || !this.user.password) {
      this.showToast("danger", "Bắt buộc nhập email và mật khẩu", "");
    } else {
      this.submitted = true;
      this.loading = true;
      this.userService.register(this.shop, this.user).subscribe(
        (userRecord) => {
          console.log("register/userRecord:", userRecord);

          this.loading = false;
          this.showToast("success", "Tạo tài khoản", "thành công");

          this.cd.detectChanges();
          return this.router.navigateByUrl("auth/login");
        },
        (error) => {
          console.log(error);
          this.showToast("warning", "Tạo tài khoản", "thất bại");
          this.loading = false;
          this.submitted = false;
          this.showMessages.error = true;

          this.errors = [
            "Có lỗi trong khi đăng ký, Xin vui lòng tải lại trang!",
          ];
          this.cd.detectChanges();
        }
      );
    }
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
